import { render, staticRenderFns } from "./NotableIndividualIcon.vue?vue&type=template&id=7a9e7a44&scoped=true"
import script from "./NotableIndividualIcon.vue?vue&type=script&lang=js"
export * from "./NotableIndividualIcon.vue?vue&type=script&lang=js"
import style0 from "./NotableIndividualIcon.vue?vue&type=style&index=0&id=7a9e7a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9e7a44",
  null
  
)

export default component.exports